
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {translate} from "@/auxillary/translation";
import {stringify} from '@/auxillary/datafield.stringify';
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'CheckBoxField',
  components: {
    Hints,
    DataFieldBar,
    OkDialog
  },
})
export default class CheckBoxField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return !this.field.isEditable;
  }

  get field() {
    return this.dataField;
  }

  get value() {
   return this.dataField?.values?.value;
  }

  set value(value: boolean) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown;
  }

  set unknown(value: boolean) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "unknown", value})
    this.value = false;
  }

  get displayName() {
    if (!this.dataField.displayName)
      return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }


  get isRequired() {
    return this.dataField.isRequired
  }

  translate(displayKey: string) {
    return translate(displayKey)
  }
}
